import { PayloadAction } from '@reduxjs/toolkit';
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash/isEqual';
import * as consumptionActionCreators from './consumption/action-creators';
import * as servicesActionCreators from './services/action-creators';
import * as bankAccountsActionCreators from './bank-accounts/action-creators';
import * as eventsInformationActionCreators from './events-information/action-creators';
import * as fiscalYearsActionCreators from './fiscal-years/action-creators';
import * as todoActionCreators from './todo/action-creators';
import * as investorBankAccountsActionCreators from './investor-bank-accounts/action-creators';

const actions = {
  ...consumptionActionCreators,
  ...servicesActionCreators,
  ...bankAccountsActionCreators,
  ...eventsInformationActionCreators,
  ...fiscalYearsActionCreators,
  ...todoActionCreators,
  ...investorBankAccountsActionCreators,
};

type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;

export type ActionTypes = ReturnType<InferValueTypes<typeof actions>>;

export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  isEqual
);

export type EnhancedPayloadAction<
  T extends {},
  K extends keyof T
> = PayloadAction<T[K]>;
